import * as types from './Constant';


export const getPatientDetails = () => {
    return {
        type: types.PATIENT_DETAILS_GET,
    };
};

export const getPatientDetailsSuccess = (payload) => ({
    type: types.PATIENT_DETAILS_GET_SUCCESS,
    payload,
});
  
export const getDoctorSlots = () => ({
    type: types.GET_SLOTS_DOC,
});


export const getDoctorSlotsSuccess = (payload) => ({
    type: types.GET_SLOTS_DOC_SUCCESS,
    payload,
});

export const getDoctorDetails = () => ({
    type: types.DOC_DETAILS_GET_CAMPAIGN,
});

export const getDoctorDetailsSuccess = (payload) => ({
    type: types.DOC_DETAILS_GET_CAMPAIGN_SUCCESS,
    payload,
});

export const getDepartmentDoctors = () => ({
    type: types.DEPARTMENT_DOC_LISTING,
});

export const getDepartmentDoctorsSuccess = (payload) => ({
    type: types.DEPARTMENT_DOC_LISTING_SUCCESS,
    payload,
});

export const campaignFailed = () => ({
    type: types.FAILED_CAMPAIGN_DOC,
});

export const updateScheduleSlotRequest = ( payload) => ({
    type: types.UPDATE_SCHEDULE_DATA_SLOT,
    payload : payload
});

export const updateScheduleSlotRequestSuccess = (data) => ({
    type: types.UPDATE_SCHEDULE_DATA_SLOT_SUCCESS,
    data : data

});

export const updateScheduleSlotRequestError = () => ({
    type: types.UPDATE_SCHEDULE_DATA_SLOT_ERROR
});